import { Component, Inject, forwardRef } from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `<footer class="tw-w-full tw-p-2 tw-text-white tw-bg-static-800 tw-text-center"> © {{ copyrightYear }} CIEE Inc. All Rights Reserved.</footer>`,
    standalone: false
})
export class AppFooterComponent {
  copyrightYear = new Date().getFullYear();
}
